import {
  containsNumber,
  containsUpperCaseLetter,
  containsLowerCaseLetter,
  hasValidLength
} from 'helpers/password_validator';

angular.module('public').controller('InvitationCtrl', ["$scope", "$stateParams", "$http", function($scope, $stateParams, $http) {
  var getError;
  $http.get(`/mobile_users/invitations/${$stateParams.hash}`).then(function(response) {
    return $scope.invitation = response.data;
  });
  $scope.data = {};
  getError = function() {
    switch (false) {
      case $scope.data.password === $scope.data.passwordConfirmation:
        return 'Passwords do not match';
      default:
        return void 0;
    }
  };
  $scope.containsNumber = function() {
    return containsNumber($scope.data.password);
  };
  $scope.containsUpperCaseLetter = function() {
    return containsUpperCaseLetter($scope.data.password);
  };
  $scope.containsLowerCaseLetter = function() {
    return containsLowerCaseLetter($scope.data.password);
  };
  $scope.hasValidLength = function() {
    return hasValidLength($scope.data.password);
  };
  $scope.submit = function() {
    var params;
    $scope.error = getError();
    if ($scope.error) {
      return;
    }
    $scope.isLoading = true;
    params = {
      cs: $stateParams.cs,
      invitation: {
        password: $scope.data.password,
        password_confirmation: $scope.data.passwordConfirmation
      }
    };
    return $http.put(`/mobile_users/invitations/${$stateParams.hash}`, params).then(function(response) {
      $scope.isLoading = false;
      return window.location.href = response.data.redirect_url;
    }, function(response) {
      var error, ref;
      $scope.isLoading = false;
      error = (ref = response.data.errors.password) != null ? ref[0] : void 0;
      if (error) {
        return $scope.error = `Password ${error}`;
      }
    });
  };
  return $scope.requestInvitation = function() {
    var url;
    $scope.isLoading = true;
    url = `/mobile_users/invitations/${$stateParams.hash}/request_new_invite?gid=${$stateParams.gid}`;
    return $http.put(url).then(function() {
      $scope.isLoading = false;
      return $scope.invitationRequested = true;
    }, function(response) {
      return $scope.isLoading = false;
    });
  };
}]);
